// extracted by mini-css-extract-plugin
export var hideEditor = "_gk-2";
export var infoIcon = "_gk-3";
export var label = "_gk-1";
export var labelContainer = "_gk-0";
export var readonlyText = "_gk-4";